export default __webpack_public_path__ + "static/media/robbit-logo.39f7f87a.png";